var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(true)?_c('headers'):_vm._e(),_c('router-view'),(true)?_c('footers'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }